import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import qs from 'qs';
import {
  makeSelectClientDetails,
  makeSelectRegion,
  makeSelectShowRegionBanner,
  makeSelectLandingMenu,
  makeSelectLanguage,
  makeSelectShowLanguageBanner,
  makeSelectShowHomepagePro,
} from 'containers/Main/selectors';
import { createStructuredSelector } from 'reselect';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { useLocation } from 'react-router-dom';

const stateSelector = createStructuredSelector({
  clientDetails: makeSelectClientDetails(),
  landingMenu: makeSelectLandingMenu(),
  region: makeSelectRegion(),
  showRegionBanner: makeSelectShowRegionBanner(),
  language: makeSelectLanguage(),
  showLanguageBanner: makeSelectShowLanguageBanner(),
});

function useTopBar() {
  const { clientDetails, showRegionBanner, showLanguageBanner } = useSelector(
    stateSelector,
  );

  const showHomepagePro = useSelector(makeSelectShowHomepagePro());
  const location = useLocation();
  const params = qs.parse(location.search.slice(1));
  const isCorporateSite = params.showcorp === '1' || showHomepagePro;

  const [showTopBar, setShowTopBar] = useState(false);
  const hasMultipleLanding =
    _get(clientDetails, 'landingLinksCollection.items', []).length > 1;
  useEffect(() => {
    const hasClientDetails = !_isEmpty(clientDetails);
    const topBarCondition =
      !isCorporateSite &&
      (showRegionBanner || hasMultipleLanding || showLanguageBanner) &&
      (!hasClientDetails ||
        (hasClientDetails &&
          (showRegionBanner || hasMultipleLanding || showLanguageBanner)));
    setShowTopBar(topBarCondition);
  }, [clientDetails, showRegionBanner, showLanguageBanner]);

  return { showTopBar };
}

export default useTopBar;
